<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title"><a id="page_vii"></a>Contents</h1>
<h2 class="toca"><a href="#/xhtml/05_Foreword"><em class="italic">Foreword</em></a></h2>
<h2 class="toca"><a href="#/xhtml/06_Introduction"><em class="italic">Introduction</em></a></h2>
<h2 class="toca"><a href="#/xhtml/07_Prologue"><em class="italic">Prologue</em></a></h2>
<h2 class="toc"><a href="#/xhtml/08_Chapter1"><span class="sp_toc">Chapter 1</span> The Journey to War</a></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter2" title="Link target outside of Sample"><span class="sp_toc">Chapter 2</span> Rouge Croix and Christmas</span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter3" title="Link target outside of Sample"><span class="sp_toc">Chapter 3</span> Trench and Billet</span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter4" title="Link target outside of Sample"><span class="sp_toc">Chapter 4</span> A Sanctuary and Holding a Line</span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter5" title="Link target outside of Sample"><span class="sp_toc">Chapter 5</span> The Raid</span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter6" title="Link target outside of Sample"><span class="sp_toc">Chapter 6</span> Craters and the Colour Blue</span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter7" title="Link target outside of Sample"><span class="sp_toc">Chapter 7</span> The Somme and Mametz Wood</span></h2>
<h2 class="toc"><span href="#/xhtml/15_Chapter8" title="Link target outside of Sample"><span class="sp_toc">Chapter 8</span> A Respite of Sorts</span></h2>
<h2 class="toc"><span href="#/xhtml/16_Chapter9" title="Link target outside of Sample"><span class="sp_toc">Chapter 9</span> The Yser Canal</span></h2>
<h2 class="toc"><span href="#/xhtml/17_Chapter10" title="Link target outside of Sample"><span class="sp_toc">Chapter 10</span> Sniping School and Observation</span></h2>
<h2 class="toc"><span href="#/xhtml/18_Chapter11" title="Link target outside of Sample"><span class="sp_toc">Chapter 11</span> 1917–1918</span></h2>
<h2 class="toca1"><span href="#/xhtml/19_Epilogue" title="Link target outside of Sample"><em class="italic">Epilogue</em></span></h2>
<h2 class="toca"><span href="#/xhtml/20_Notes" title="Link target outside of Sample"><em class="italic">Notes</em></span></h2>
<h2 class="toca"><span href="#/xhtml/21_Abbreviations" title="Link target outside of Sample"><em class="italic">Abbreviations</em></span></h2>
<h2 class="toca"><span href="#/xhtml/22_Glossary" title="Link target outside of Sample"><em class="italic">Glossary</em></span></h2>
<h2 class="toca"><span href="#/xhtml/23_Bibliography" title="Link target outside of Sample"><em class="italic">Bibliography</em></span></h2>
<h2 class="toca"><span href="#/xhtml/24_Acknowledgements" title="Link target outside of Sample"><em class="italic">Acknowledgements</em></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?628b6da4